import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
export default new Router({
    routes: [
        // 重定向redirect

        // {
        //     path:'/home',
        //     // component:Home//
        //     component:()=>import('@/components/Home.vue')//路由懒加载
        //     // component:resolve=>require(['@/components/Home.vue'],resolve)//异步组件加载
        // },

        {
            path: "/",
            name: "home",
            iconClass: "fa fa-users",
            component: () => import("@/components/Home.vue"),
            meta: {title: "测试专区"},
            children: [],
        },
        {
            path: "/home",
            name: "home",
            iconClass: "fa fa-users",
            component: () => import("@/components/Home.vue"),
            meta: {title: "测试专区"},
            children: [],
        },
        {
            path: '/qqqx',
            name: "qqqx",
            iconClass: "fa fa-list",
            component: () => import("@/components/qqqx.vue"),
            meta: {title: "BDSM测试情趣倾向测试"},
        },
        {
            path: "/qqqxMBTI",
            name: "qqqxMBTI",
            iconClass: "fa fa-list",
            component: () => import("@/components/qqqxMBTI.vue"),
            meta: {title: "MBTI十六人格测试"},
        },
        {
            path: "/answer",
            name: "answer",
            iconClass: "fa fa-list",
            component: () => import("@/components/answer.vue"),
            meta: {title: "BDSM测试情趣倾向测试"},
        },
        {
            path: "/result",
            name: "result",
            iconClass: "fa fa-list",
            component: () => import("@/components/result.vue"),
            meta: {title: "BDSM测试情趣倾向测试"},
        },

        {
            path: "/answerMBTI",
            name: "answerMBTI",
            iconClass: "fa fa-list",
            component: () => import("@/components/answerMBTI.vue"),
            meta: {title: "MBTI十六人格测试"},
        },
        {
            path: "/resultMBTI",
            name: "resultMBTI",
            iconClass: "fa fa-list",
            component: () => import("@/components/resultMBTI.vue"),
            meta: {title: "MBTI十六人格测试"},
        },
    ],
    mode: "history",
});
